<template>
  <div class="hc-compact-page appointment-entry-page">

    <PageHeader
      :title="`Buat Perjanjian Baru ${clinic_name}`"
      subtitle="Atur pasien, dokter, waktu, tindakan, dan ruangan dalam satu formulir"
      icon="far fa-calendar-plus"
    />

    <div class="row">
      <div class="col-md-12">
        <Card :title="'Informasi Perjanjian'" card-class="appointment-entry-card">
          <template v-slot:body>
            <Form
              :initial-form="form"
              :route="'appointments'"
              :purpose="'add'" />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/appointments/Form.vue'
import PageHeader from "@/component/general/PageHeader.vue"
import { getConfiguration } from '@/core/services/jwt.service.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  name: 'Add',

  components: {
    Card,
    Form,
    PageHeader
  },

  data() {
    return {
      form: {
        id: null,
        room_id: '',
        patient_id: '',
        coverage_type: 'umum',
        bpjs_card_number: '',
        bpjs_participant_status: '',
        bpjs_verified_at: '',
        bpjs_fktp_code: '',
        bpjs_fktp_name: '',
        complaint: '',
        doctor_id: '',
        action_type_id: '',
        date: '',
        doctor_time_slot_id: '',
        quote_start_time: '',
        quote_end_time: '',
        live_meeting_link: '',
        appointment_status_id: 1,
        notes: ''
      },
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pendaftaran atau Perjanjian" },
      { title: "Daftar atau Buat Janji" },
    ])
    if (getConfiguration().appointment_confirmation == 1)
      this.form.appointment_status_id = 3
  }

}
</script>

<style lang="scss">
.hc-schedule-header-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #ffffff;
  border: 1px solid #e7edf4;
  border-radius: 16px;
  box-shadow: 0 10px 28px rgba(20, 50, 99, 0.05);
}

.hc-schedule-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  margin-right: 16px !important;
  border-radius: 12px;
  background: rgba(30, 149, 143, 0.08);
  color: #1e958f;
  font-size: 18px;
}

.hc-schedule-header-title {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
  color: #1a2433;
}

.hc-schedule-header-sub {
  font-size: 12px;
  color: #64748b;
}
</style>
